import { LOADING, MESSAGE, MESSAGE_RESERVATION } from './constants';

export const loading = async (dispatch, loading) => dispatch({ type: LOADING, loading });

export const message = async (dispatch, message) => dispatch({ type: MESSAGE, message });

export const messageReservation = async (dispatch, messageReservation) => dispatch({ type: MESSAGE_RESERVATION, messageReservation });